module.exports = __webpack_public_path__ + "static/media/Icon_5.9af3337a.svg";